<template>
    <header class=" fixed-top app-header-inter-pages dash-header page-container">
        <div class="container-fluid py-12  border-bottom px-0">
            <div>
                <NuxtLayout name="header" />

            </div>

        </div>
        

    </header>

    <main class=" container-fluid pt-80 terms-container px-0">
        <div class="main-content w-100 px-0">
          <slot />
        </div>
    </main>
    <NuxtLayout name="footer"></NuxtLayout>

</template>

<script setup>



</script>

<style lang="scss" scoped>

</style>